module.exports = __webpack_public_path__ + "img/Info-Triangle.be6b7e76.svg";